<!-- <ngx-charts-bar-vertical-stacked [scheme]="colorScheme" [results]="results" [xAxis]="false" [yAxis]="false"
    [showXAxisLabel]="false" [showYAxisLabel]="false" [animations]="true">
</ngx-charts-bar-vertical-stacked> -->
<canvas baseChart class="h-64" [datasets]="barChartData.datasets" [labels]="barChartData.labels"
    [options]="barChartOptions" [type]="'bar'" [plugins]="barChartPlugins">
</canvas>